<template>
    <div id="registration-landing-container">



    <v-container grid-list-lg>
        <v-layout row>
            <v-flex xs12 class="text-xs-center display-1 font-weight-black my-5">Current OFB Webhooks Available</v-flex>
        </v-layout>
        <div>Webhook setup instructions will be emailed to you upon purchase.</div>
        <br>
        <div>All Webhooks can be piped directly into any channel you want in your Discord room.</div>
        <br>
        <v-select
                v-model="selected_tags"
                :items="tags"
                label="Select Webhooks"
                filled dense clearable chips multiple
        >
            <template v-slot:selection="{ item }">
                <v-chip text-color="white" :color="item.color" small
                >{{ item.text }}</v-chip>
            </template>
            <template v-slot:item="{ active, item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                    <v-list-item-action>
                        <v-checkbox :input-value="active"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            <v-row no-gutters align="center">
                                <span>{{ item.descr }}</span>
                                <v-spacer></v-spacer>
                                <v-chip text-color="white" :color="item.color" small
                                >{{ item.text }}</v-chip>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-select>
        <div id="button-container">
        <v-btn
                large
                class="ma-2 white--text"
                id="prem-button"
                v-on:click="buyWebhooks()"
        >
            Purchase Webhooks
        </v-btn>
            <br>
        </div>

        <v-layout row wrap>
            <v-flex xs12 sm12 md4>
                <v-card height="100%" elevation="11" :style="'border: 3px solid grey'">
                    <v-responsive>
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>

                                    <span class="headline white--text">Opening Options Flow </span>
                                    <span class="headline grey--text"> - 50$/mo</span>
                                </v-flex>
                            </v-layout>
                        </v-container>

                    </v-responsive>
                    <v-card-text>
                        <div>
                            <h3 class="headline mb-0">Features </h3>
                            <li v-for="freeStuff in freeStuffs" :key="freeStuff.message">
                                {{ freeStuff.message }}
                            </li>
                            <br />
                        </div>
                    </v-card-text>
                    <div class="imagecenter">

                        <v-img
                                max-height="288"
                                max-width="277"
                                src="/assets/openingflow.png"
                        >
                        </v-img>
                    </div>

                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-card height="100%" elevation="11" :style="'border: 3px solid green'">
                    <v-responsive>
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>
                                    <span class="headline white--text">Large Options Flow </span>
                                    <span class="headline grey--text"> - 50$/mo</span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-responsive>

                    <v-card-text>
                        <div>
                            <h3 class="headline mb-0">Features </h3>
                            <li v-for="standardStuff in standardStuffs" :key="standardStuff.message">
                                {{ standardStuff.message }}
                            </li>
                            <br />
                        </div>
                    </v-card-text>
                    <div class="imagecenter">

                        <v-img
                                max-height="288"
                                max-width="277"
                                src="/assets/largeflow.png"
                        >
                        </v-img>
                    </div>

                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-card height="100%" elevation="11" :style="'border: 3px solid blue'">
                    <v-responsive>
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>
                                    <span class="headline white--text">Large Dark Pool / Block </span>
                                    <span class="headline grey--text"> - 50$/mo</span>

                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-responsive>
                    <v-card-text>
                        <div>
                            <h3 class="headline mb-0">Features </h3>
                            <li v-for="premiumStuff in premiumStuffs" :key="premiumStuff.message">
                                {{ premiumStuff.message }}
                            </li>
                            <br />
                        </div>
                    </v-card-text>
                    <div class="imagecenter">

                        <v-img
                                max-height="248"
                                max-width="247"
                                src="/assets/darkpoolflow.png"
                        >
                        </v-img>
                    </div>
                    <br>
                </v-card>
            </v-flex>
        </v-layout>





    </v-container>
    </div>
</template>

<script>
    import {BASE_URL} from "../../utils/constants"
    import {COOKIE_USER_AUTH, COOKIE_USER_ID, setCookieWithMonthExpiry} from "../../utils/CookieHelper";
    import {AUTH} from "@/firebase/config";
    import FeatureList from "../../features.json";

    const ENDPOINT = "api/v1/discord/oauth"

    export default {
        created() {
            //let discordCode = this.$route.query.code ? this.$route.query.code : ""
            //this.parseQueryString(discordCode)
            //this.exchangeCodes(discordCode)
        },
        name: "WebhooksLanding",
        methods: {
            buyWebhooks: function() {
                this.$router.push({name: "PaymentWebhooks", params: {webhooks: this.selected_tags, userID: COOKIE_USER_ID}})
            },
            parseQueryString: function (discordCode){
                if (discordCode.length < 1) {
                    this.$router.push({name: "Login"})
                }
            },
            exchangeCodes: async function(discordCode) {

                fetch(BASE_URL + ENDPOINT + "?code=" + discordCode, {method: 'post'})
                    .then(response => {
                        this.parseResponse(response)

                    })
                    .catch(error => {
                        alert(error)
                        this.$router.push({name: "Login"})
                    })
            },

            parseResponse: function(response) {

                if (response.status === 200 || response.status === 301) {
                    response.json().then(respData => {

                        // This means user is not registered, so they must continue on with the registration process
                        if (response.status === 200) {
                            this.userInfo = {
                                username: `${respData.message.username}#${respData.message.discriminator}`,
                                avatar: `https://cdn.discordapp.com/avatars/${respData.message.id}/${respData.message.avatar}.jpg`,
                                userID: respData.message.id,
                                userEmail: respData.message.email,
                            }
                        }

                        // Set cookies with userID and userAuthToken for later use
                        setCookieWithMonthExpiry(COOKIE_USER_AUTH, respData.token)
                        setCookieWithMonthExpiry(COOKIE_USER_ID, respData.message.id)

                        //console.log(getCookie(COOKIE_USER_AUTH));





                        AUTH.signInWithCustomToken(respData.fbtoken)
                            .then((userCredential) => {
                                // Signed in
                                const user = userCredential.user;
                                console.log(user);
                                // ...
                            })
                            .catch((error) => {
                                const errorCode = error.code;
                                const errorMessage = error.message;
                                console.log(errorCode);
                                console.log(errorMessage);
                                // ...
                            });

                        // This means the user IS registered, so instead they get sent back to dashboard after the cookies are set
                        if (response.status === 301) {
                            this.$router.push({name: "DashMain"})
                        }
                        this.ready = true;
                    })
                } else {
                    alert("There was an error with your request, please try again later")
                    //Send Back
                    this.$router.push({name: "Login"})
                }

            },

            tierSelected: function(tier) {
                console.log(tier);
                console.log(this.userInfo.userID);
                console.log(this.userInfo.userEmail);
                this.$router.push({name: "Payment",  params: {selectedTier: tier, userID: this.userInfo.userID, userEmail: this.userInfo.userEmail, avatar:this.userInfo.avatar}})
            }
        },

        data: () => ({
            selected_tags: [],
            tags: [
                {
                    value: "OpeningFlow",
                    text: "Opening Options Flow - All flow where Volume > Open Interest and Value > $500,000",
                    descr: "Opening Options Flow",
                    color: "#00000",
                    virtual: true,
                    hidden: false,
                    locked: false
                },
                {
                    value: "LargeFlow",
                    text: "Large Options Flow - All flow where Value > $1 Million",
                    descr: "Large Options Flow",
                    color: "#25422b",
                    virtual: false,
                    hidden: false,
                    locked: false
                },
                {
                    value: "LargeDP",
                    text: "Large Dark Pool / Block Orders - All Blocks / Dark Pool orders over $50 Million in value",
                    descr: "Large Dark Pool / Block",
                    color: "#184f24",
                    virtual: false,
                    hidden: false,
                    locked: false
                }
            ],
            features: FeatureList,
            freeStuffs:[
                {"message": "Opening Options Flow - All flow where Volume > Open Interest and Value > $500,000"},
                {"message": "Real Time"}
            ],
            standardStuffs:[
                {"message": "Large Options Flow - All flow where Value > $1 Million"},
                {"message": "Real Time"}
            ],
            premiumStuffs:[
                {"message": "Large Dark Pool / Block Orders - All Blocks / Dark Pool orders over $50 Million in value"},
                {"message": "15m delayed"}
            ],
            tiers: [
                             {
                                 index: 0,
                                 title: "OFB Free",
                                 subtitle: "Current Subscription for anyone using OFB without a plan.",
                                 // make this T1 if you put it back - making it T2 incase someone accidently picks it.
                                 id: "OF_Free",
                                 price: "$5/mo",
                                 color: "#2180CE",
                                 description: "OptionsFamBot Membership - Discord Only"
                             },
                             {
                                 //make this index 1 if you add back in tier 1
                                 index: 1,
                                 title: "OFB Standard",
                                 subtitle: "Current Subscription for anyone using OFB without a plan.",
                                 id: "OF_T1",
                                 price: "$20/mo",
                                 color: "#BBA801",
                                 description: "OFBot Premium with Dark Pool and Options Flow on site"
                             },
                             {
                                 //make this index 1 if you add back in tier 1
                                 index: 2,
                                 title: "OFB Flow and Darkpool",
                                 subtitle: "Current Subscription for anyone using OFB without a plan. Users get 15 Free commands a month for DarkPool and Options Data.",
                                 id: "OF_T2",
                                 price: "$20/mo",
                                 color: "#BBA801",
                                 description: "OFBot Premium with Dark Pool and Options Flow on site"
                             },
                         ],
            userInfo: {}
        }),
    }
</script>

<style scoped>
    h2 {
        margin-bottom: 1rem;
    }

    #loading-container {
        height: 100vh;
        width: 100vw;
    }
    #prem-button {
        height: 52px;
        background-color: #15454b;
    }
    #loading-overlay {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    #loading-text {
        margin-top: 2rem;

    }

    #registration-landing-container {
        width: 100%;
        height: 100%;
        padding: 16px 16px 10px 16px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }

    #user-info {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    #user-name {
        margin-right: 1rem;
    }
    .imagecenter {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    #content-wrapper {
        height: 90%;
    }
    #button-container {
        display: grid;
        align-self: start;
        align-items: start;
        grid-template-rows: fit-content(1em) fit-content(1em) fit-content(1em);

        height: auto;
        width: 40%;
        margin-top: 5px;
    }
    #join-tier {
        width: 100%;
        margin-top: 2rem;
    }

    #selection-carousel {
        margin: 1rem 0;
    }

    #features-table {
        background-color: #404040;
        box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
    }
    .media{
        border-radius:3%;
    }
    .media:hover{
        box-shadow: 0 0 3pt 2pt #ff5555;
        border-radius:3%;
        cursor: pointer;
    }
    .card-actions {
        position: absolute;
        bottom: 0;
    }
    .text{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: default;
        width: 100%;
        position: absolute;
    }
    .block{
        display: block !important;
        height: 104px;
    }

    @media screen and (min-width: 750px) {
        h1 {
            display: none;
        }

        #content-wrapper {
            width: 50%;
            max-width: 564px;
            margin: auto;
            height: fit-content;
            background-color: #404040;
            padding: 32px;
            border-radius: 10px;
            box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
        }
    }
</style>